// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610210306/js/" + chunkId + "." + {"44":"3e3903e8","225":"2e3b3432","481":"cccfd60b","486":"81000fe2","770":"fe7cac19"}[chunkId] + ".0.8039788256920268.chunk.js";
};